/* Marinelie — immer das Schubfach, nie die Warenkorbseite.

   Ein gewoehnliches Formular auf /cart/add laedt die Seite neu, und
   Shopify schickt danach auf /cart. Wo im Haus so ein Formular steht,
   faengt dieses Blatt es ab und legt ueber /cart/add.js nach, genau
   wie Dawns product-form es tut — inklusive der Sections, die das
   Schubfach danach neu zeichnet.

   Formulare in einem <product-form> bleiben unberuehrt: darum
   kuemmert sich Dawn schon. Fehlt das Schubfach im Dokument, laeuft
   alles wie zuvor auf die Seite — lieber der alte Weg als gar keiner. */
(function () {
  function schubfach() {
    var el = document.querySelector('cart-drawer');
    return el && typeof el.renderContents === 'function' ? el : null;
  }

  function oeffnen(el) {
    if (typeof el.open === 'function') el.open();
  }

  function unserFormular(form) {
    if (!form || form.tagName !== 'FORM') return false;
    if ((form.getAttribute('action') || '').indexOf('/cart/add') === -1) return false;
    if (form.closest('product-form')) return false;
    return !!schubfach();
  }

  /* Shopifys Zaehler (Pixel-Manager und Analytics) haengen direkt am
     Formular und werten ein Absenden auf /cart/add als "In den Warenkorb",
     wenn es dort noch nicht verhindert ist; den fetch unten zaehlt der
     Pixel-Manager danach ein zweites Mal. Jeder Klick auf den Kaufknopf
     der Duftseiten V4 ging so doppelt an Meta (2 AddToCart, Korb 1;
     ADS / CONTENT und Test am 02.11.2026). Darum wird das Absenden schon
     in der Erfassungsphase verhindert, vor allen Formular-Handlern.
     Entschieden wird weiter unten am document wie bisher. Ob ein anderer
     Handler (Duftwahl, Schwebeleiste, YMQ-Sperre, Vorab) das Absenden
     uebernommen hat, zeigte bisher e.defaultPrevented; das ist jetzt
     immer gesetzt, also merkt sich das Ereignis jeden weiteren Aufruf. */
  window.addEventListener(
    'submit',
    function (e) {
      if (!unserFormular(e.target)) return;
      var verhindern = e.preventDefault;
      verhindern.call(e);
      e.mlUebernommen = false;
      e.preventDefault = function () {
        e.mlUebernommen = true;
        verhindern.call(e);
      };
    },
    true
  );

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || form.tagName !== 'FORM') return;
      if (e.mlUebernommen === undefined ? e.defaultPrevented : e.mlUebernommen) return;

      var ziel = form.getAttribute('action') || '';
      if (ziel.indexOf('/cart/add') === -1) return;
      if (form.closest('product-form')) return;

      var korb = schubfach();
      if (!korb) return;

      e.preventDefault();

      var knopf = form.querySelector('[type="submit"]');
      if (knopf) knopf.setAttribute('aria-disabled', 'true');

      var daten = new FormData(form);
      daten.append(
        'sections',
        korb.getSectionsToRender().map(function (s) {
          return s.id;
        })
      );
      daten.append('sections_url', window.location.pathname);

      fetch(window.routes ? window.routes.cart_add_url : '/cart/add', {
        method: 'POST',
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: daten,
      })
        .then(function (r) {
          return r.json();
        })
        .then(function (antwort) {
          if (antwort.status) {
            /* Shopify hat abgelehnt — die Seite darf die Meldung zeigen. */
            form.submit();
            return;
          }
          korb.classList.remove('is-empty');
          korb.renderContents(antwort);
          oeffnen(korb);
        })
        .catch(function () {
          form.submit();
        })
        .finally(function () {
          if (knopf) knopf.removeAttribute('aria-disabled');
        });
    },
    /* In der Erfassungsphase, damit wir vor eigenen Handlern der
       Sections stehen und nicht hinter ihnen. */
    false
  );
})();
